// frontend/src/modules/payments/api.ts
import { api } from '../../core/api-client';
import type {
  TenantPaymentGateway, TenantPaymentGatewayInput,
  PaymentsPage, Refund, InitiateRefundInput,
} from './types';

export const paymentsApi = {
  // Returns the whole envelope: `webhook_url` is present even when `config` is
  // null, because that is precisely when the owner needs the endpoint URL to
  // paste into Stripe.
  getGatewayConfig: () =>
    api<{ config: TenantPaymentGateway | null; webhook_url: string }>('/api/payments/gateway-config'),
  putGatewayConfig: (input: TenantPaymentGatewayInput) =>
    api<{ config: TenantPaymentGateway }>('/api/payments/gateway-config', { method: 'PUT', body: input }).then((r) => r.config),

  list: (opts: { invoiceId?: string; limit?: number; offset?: number } = {}) => {
    const qs = new URLSearchParams();
    if (opts.invoiceId) qs.set('invoice_id', opts.invoiceId);
    if (opts.limit) qs.set('limit', String(opts.limit));
    if (opts.offset) qs.set('offset', String(opts.offset));
    const suffix = qs.toString() ? `?${qs}` : '';
    return api<PaymentsPage>(`/api/payments${suffix}`);
  },

  payLink: (invoiceId: string) =>
    api<{ url: string; session_id: string }>('/api/payments/pay-link', {
      method: 'POST',
      body: { invoice_id: invoiceId },
    }),

  listRefunds: (invoiceId?: string) => {
    const suffix = invoiceId ? `?invoice_id=${encodeURIComponent(invoiceId)}` : '';
    return api<{ refunds: Refund[] }>(`/api/payments/refunds${suffix}`).then((r) => r.refunds);
  },

  initiateRefund: (input: InitiateRefundInput) =>
    api<{ refund: Refund }>('/api/payments/refunds', { method: 'POST', body: input }).then((r) => r.refund),
};
